// extracted by mini-css-extract-plugin
module.exports = {"checkboxesContainer":"CreateEditClinics_checkboxesContainer__1sk0H","emails":"CreateEditClinics_emails__1EBYX","emailTagLabel":"CreateEditClinics_emailTagLabel__31z-K"};